import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { accountingApi } from '../../services/accountingApi';
import '../../styles/accounting.css';

const money = (n) =>
    `S/ ${Number(n || 0).toLocaleString('es-PE', {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
    })}`;

export default function AccountingScheduled() {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        accountingApi.scheduledPayments().then((r) => setRows(r.rows || []));
    }, []);

    return (
        <div>
            <Header namePage="accountingScheduledPage" />

            <section className="sectionBody sectionBodyAccounting">
                <div className="containerBody">
                    <main className="accountingPage">
                        <header className="accHero">
                            <div>
                                <span>Programación</span>
                                <h1>Pagos programados, proveedores y préstamos</h1>
                                <p>
                                    Control de obligaciones fijas, facturas por pagar y préstamos
                                    bancarios.
                                </p>
                            </div>
                        </header>

                        <section className="accCard tableWrap">
                            <table className="accTable">
                                <thead>
                                    <tr>
                                        <th>Vence</th>
                                        <th>Tipo</th>
                                        <th>Proveedor</th>
                                        <th>Concepto</th>
                                        <th>Área</th>
                                        <th>Sede</th>
                                        <th>Monto</th>
                                        <th>Estado</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {rows.map((x) => (
                                        <tr key={x.id}>
                                            <td>{x.due_date?.slice(0, 10)}</td>
                                            <td>{x.type}</td>
                                            <td>{x.supplier || x.business_name}</td>
                                            <td>{x.concept}</td>
                                            <td>{x.area_name}</td>
                                            <td>{x.sd_sede || '-'}</td>
                                            <td className="amount">{money(x.amount)}</td>
                                            <td>
                                                <span className="pill">{x.status}</span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </section>
                    </main>
                </div>
            </section>

            <Footer />
        </div>
    );
}
